export enum SegmentationCopyTypeEnum {
    all = "Копирование сегментации агентам",
    ruleToCurrent = "Копирование правила в текущую сегментацию",
    rule = "Копирование правила агентам",
}

export enum SegmentationCopyRuleTypeEnum {
    antisegment = "Антисегмент",
    segment = "Сегмент",
}
